module.exports = __webpack_public_path__ + "feaa8caafe287ce5013d3ec3bcfedeb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/young-orangutan.jpg
// module id = 1780
// module chunks = 0